import React from "react";
import { Routes, Route } from "react-router-dom";
import HomePage from "./pages/HomePage.tsx";
import MainApp from "./pages/AppPage.js";
import AuthPage from "./pages/Login.tsx";
import TestPage from "./pages/test.js";

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/app" element={<MainApp />} />
      <Route path="/login" element={<AuthPage />} />
      <Route path="/test" element={<TestPage />} />
    </Routes>
  );
}